var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.promptBubble)?_c('div',{staticClass:"prompt-bubble-box"},[_c('p',[_vm._v("专业版可以自定义大纲哦")]),_c('el-button',{staticClass:"prompt-bubble-btn",attrs:{"icon":"el-icon-close","circle":""},on:{"click":_vm.promptBubbleBtn}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }